<template>
  <div class="section__container">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://www.thesill.com/" target="_blank">
            <h4 class="client">Scoutside</h4>
          </a>
          <h1 class="title">
            {{ $t("theSill.title") }}
          </h1>
          <p class="date">
            {{ $t("theSill.duration.title") }}
            {{ $t("theSill.duration.date") }}
          </p>
          <p class="role">
            {{ $t("theSill.position.title") }}
            {{ $t("theSill.position.role") }}
          </p>
          <p class="description">
            {{ $t("theSill.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("theSill.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("theSill.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("theSill.bullet3") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("theSill.bullet4") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img src="@/assets/the-sill.png" alt="" class="demo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>
<style lang="scss" scoped>
div.section__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 0;

  @media (min-width: 600px) {
    height: 100vh;
    padding: 0;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      color: gray;
      font-weight: bold;
      // font-family: "Raleway";
    }

    h1.title {
      //color: #fff;
      font-family: "Raleway";
      text-align: start;
    }

    p.description {
      text-align: left;
      font-weight: 700;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #000;
      font-size: 1.2rem;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      color: #000;
      li {
        text-align: left;
        margin: 1rem 0;
        // font-weight: 500;
      }
    }
  }

  div.multimedia-container {
    img {
      width: 85%;
      box-shadow: 3px 3px 38px 7px #000;
    }
  }
}
</style>
